import { z } from 'zod';

import { PERMISSION } from 'src/features/auth';

export type RoleFormSchemaValues = z.infer<typeof roleFormSchema>;
export const roleFormSchema = z.object({
    name: z.string().nonempty(),
    permissions: z.array(z.enum(PERMISSION)).optional(),
});
